<template>

  <HeaderSection />

  <section id="formulario" class="p-6 bg-[#2d3fa6]">

    <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-gray-700 TommyLight" @invalid-submit="onInvalidSubmit">

      <div class="container mx-auto p-6 max-w-6xl bg-white rounded-lg">

        <h1 class="font-bold text-center text-3xl uppercase TommyBlack">Acreditación</h1>
        <h1 class="font-bold text-center text-xl">Por favor complete el formulario en su totalidad</h1>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5">
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">Documento / Pasaporte</label>
            <Field name="dni" v-slot="{ field, errors }" v-model="formData.dni">
              <InputText v-bind="field" type="text" @blur="validarDni" class="input-base" placeholder="Documento" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="dni" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">Nombre</label>
            <Field name="nombre" v-slot="{ field, errors }" v-model="formData.nombre">
              <InputText v-bind="field" type="text" class="input-base" placeholder="Nombre" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="nombre" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">Apellido</label>
            <Field name="apellido" v-slot="{ field,errors }" v-model="formData.apellido">
              <InputText v-bind="field" type="text" class="input-base" placeholder="Apellido" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="apellido" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2">
            <label class="block mb-1">Tipo de acreditado</label>
            <Field name="tipoAcreditado" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.tipoAcreditado">
              <Select @blur="handleBlur" @update:model-value="handleChange" :model-value="value" optionLabel="descripcion" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}" placeholder="Seleccione el tipo de acreditación" class="input-base" :options="tiposAcreditados" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="tipoAcreditado" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-4">
          <div class="w-full px-2 md:w-6/12">
            
            <label class="block mb-1">
              <span v-if="!formData.tipoAcreditado || formData.tipoAcreditado?.id == 2713 || formData.tipoAcreditado?.id == 2711">Empresa</span>
              <span v-if="formData.tipoAcreditado?.id == 2712">Medio</span>
              <span v-if="formData.tipoAcreditado?.id == 2710">Institución educativa</span>
            </label>

            <Field name="empresa" v-slot="{ field, errors }" v-model="formData.empresa">
              <InputText v-bind="field" type="text" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" 
                :placeholder="
                  !formData.tipoAcreditado || formData.tipoAcreditado?.id == 2713 || formData.tipoAcreditado?.id == 2711 ? 'Empresa'
                  : formData.tipoAcreditado?.id == 2712? 'Medio'
                  : formData.tipoAcreditado?.id == 2710 ? 'Institución educativa'
                  : 'Empresa'" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="empresa" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Actividad / Ocupación</label>
            <Field name="ocupacion" v-slot="{ field,errors }" v-model="formData.ocupacion">
              <InputText v-bind="field" type="text" class="input-base" placeholder="Actividad / Ocupación" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="ocupacion" /></span>
            </Field>
          </div>
        </div>


        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Legajo / Agente de viajes</label>
            <Field name="numeroLegajo" v-slot="{ field, errors }" v-model="formData.numeroLegajo">
              <InputText v-bind="field" :disabled="formData.tipoAcreditado?.id !== 2713 && formData.tipoAcreditado?.id !== 2711" type="text" class="input-base" placeholder="Legajo" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="numeroLegajo" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Mail</label>
            <Field name="mail" v-slot="{ field, errors }" v-model="formData.mail">
              <InputText v-bind="field" type="mail" class="input-base" placeholder="Mail" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="mail" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-3/12">
              <label class="block mb-1">País (Teléfono)</label>
              <Select v-model="selectedCountry" filter :options="paises" optionLabel="descripcion" placeholder="Select a Country" class="input-base"/>
          </div>
          <div class="w-full px-2 md:w-2/12">
            <label class="block mb-1">Código de país</label>
            <InputText type="text" v-if="selectedCountry !== null" v-model="selectedCountry.id" class="input-base" readonly />
          </div>
          <div class="w-full px-2 md:w-3/12">
            <label class="block mb-1">Código de área</label>
            <Field name="codigoArea" v-slot="{ field, errors }" v-model="formData.codigoArea">
              <InputText v-bind="field" type="text" class="input-base" placeholder="Código de área" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"  />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="codigoArea" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">Teléfono</label>
            <Field name="numeroTelefono" v-slot="{ field, errors }" v-model="formData.numeroTelefono">
              <InputText v-bind="field" type="text" class="input-base" placeholder="Teléfono" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="numeroTelefono" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">País (Residencia)</label>
            <Field name="paisResidencia" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.paisResidencia">
              <Select filter @blur="handleBlur" @update:model-value="handleChange" :model-value="value" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}" placeholder="País de residencia" class="input-base" :options="paises" optionLabel="descripcion" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="paisResidencia" /></span>
            </Field>
          </div>

          <div class="w-full px-2 md:w-4/12" v-if="formData.paisResidencia?.id == '+54'">
            <label class="block mb-1">Provincia</label>
            <Field name="provincia" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.provincia">
              <Select @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione la provincia" :options="provincias" optionLabel="descripcion" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="provincia" /></span>
            </Field>
          </div>

          <div class="w-full px-2 md:w-4/12" v-if="formData.paisResidencia?.id != '+54'">
            <label class="block mb-1">Provincia / Estado</label>
            <Field name="provinciaEstado" v-slot="{ field, errors }" v-model="formData.provinciaEstado">
              <InputText v-bind="field" type="text"  placeholder="Ingrese su provincia o estado"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="provinciaEstado" /></span>
            </Field>
          </div>

          <div class="w-full px-2 md:w-4/12" v-if="formData.paisResidencia?.id == '+54'">
            <label class="block mb-1">Localidad</label>
            <Field name="localidad" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.localidad">
                <Select @blur="handleBlur" filter @update:model-value="handleChange" :model-value="value" placeholder="Seleccione la localidad" class="input-base" :options="localidades" optionLabel="descripcion" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}" />
                <span class="text-sm text-red-500 p-error"><ErrorMessage name="localidad" /></span>
            </Field>
          </div>

          <div class="w-full px-2 md:w-4/12" v-if="formData.paisResidencia?.id != '+54'">
            <label class="block mb-1">Localidad / Ciudad</label>
            <Field name="localidadCiudad" v-slot="{ field, errors }" v-model="formData.localidadCiudad">
              <InputText v-bind="field" type="text"  placeholder="Ingrese su localidad o ciudad"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="localidadCiudad" /></span>
            </Field>
          </div>

        </div>

        
        <div class="flex flex-wrap py-2 mt-3">
          <button type="submit"
            class="TommyLight mt-8 px-5 py-2 bg-transparent border-blue-950 hover:bg-blue-950 text-blue-950 font-semibold hover:text-white border rounded"
            :disabled="isSubmitting">
            <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
            <i v-show="!isSubmitting" class="pi pi-check mr-2"></i> REGISTRARME
          </button>
        </div>

        <div class="container mx-auto pb-10">
          <img class="object-contain mx-auto" src="@/assets/arav.png" style="max-width: 280px;" />
        </div>

      </div>


    </Form>

  </section>

  <FullScreenLoader :visible="isSubmitting" fullScreen />

</template>

<script lang="ts">
import * as yup from 'yup';
import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import InputText from 'primevue/inputtext';
import Select from 'primevue/select';
import HeaderSection from '@/components/HeaderSection.vue'

import jsonCountries from '@/data/countries.json';
import jsonProvincias from '@/data/provincias.json';
import jsonLocalidades from '@/data/localidades.json';
import jsonTiposAcreditados from '@/data/tiposAcreditados.json';

import suiteService, { Acreditado, EstadoAcreditado, IdLabelEntity, OrigenAcreditado, StringIdLabelEntity, TipoAcreditado } from 'qreventos-suite/services';

import {  SAVE, ORIGEN_ACREDITADO, VERIFICADO } from "qreventos-suite/constantes";
import suiteConfig from '@/services/suite.config';
import FullScreenLoader from './FullScreenLoader.vue';

interface Pais extends StringIdLabelEntity {}
interface Provincia extends IdLabelEntity {}
interface Localidad extends IdLabelEntity {}

export default defineComponent({
  name: 'FormSection',
  components: {
    HeaderSection,
    InputText, Select, 
    Field, ErrorMessage, Form, FullScreenLoader
  },
  data() {
    return {
      isSubmitting: false,
      paises: jsonCountries as Pais[],
      selectedCountry: {"id": "+54", "descripcion": "Argentina"} as Pais,
      tiposAcreditados: jsonTiposAcreditados as TipoAcreditado[],
      provincias: jsonProvincias as Provincia[],
      localidades: jsonLocalidades as Localidad[],
      formData: {
        dni: '',
        nombre: '',
        apellido: '',
        empresa : '',
        ocupacion:'',
        mail: '',
        numeroLegajo: '',
        codigoArea: '',
        numeroTelefono: '',
        paisResidencia: {"id": "+54", "descripcion": "Argentina"} as Pais,
        localidad: undefined as unknown as Localidad,
        localidadCiudad: '',
        provincia: undefined as unknown as Provincia,
        provinciaEstado: '',
        tipoAcreditado: undefined as unknown as TipoAcreditado,
      }
    };
  }, 
  created () {
    document.title = "ARAV | Workshop Turístico | OCT 2026";
  },
  computed: {
    schema() {
      return yup.object({
        dni: yup.string().required("Ingrese el documento").min(6, "Al menos 6 caracteres"),
        nombre: yup.string().required("Ingrese el nombre").min(3, "Al menos 3 caracteres"),
        apellido: yup.string().required("Ingrese el apellido").min(3, "Al menos 3 caracteres"),
        tipoAcreditado: yup.mixed().required("Seleccione el tipo de acreditado"),
        empresa: yup.string().required("Ingrese la empresa").min(2, "Al menos 2 caracteres"),
        ocupacion: yup.string().required("Ingrese la ocupación").min(3, "Al menos 3 caracteres"),
        codigoArea: yup.string().required("Ingrese el código de área").matches(/^\d+$/, "Debe ser numérico"),
        numeroTelefono: yup.string().required("Ingrese el telefono").matches(/^\d+$/, "Debe ser numérico"),
        mail: yup.string().required("Ingrese el mail").email("Mail inválido"),
        
        numeroLegajo: yup.string().test('validacion-numero-legajo', 'Ingrese el legajo', function(value) {
          const tipoAcreditadoSelected = this.parent.tipoAcreditado;     
          if(tipoAcreditadoSelected?.id == 2713  && !value) {
              return false;
          }
          return true;
        }),


        provincia: yup.mixed().test('validacion-provincia-argentina', 'Seleccione la provincia', function(value) {
          const paisSelected = this.parent.paisResidencia;     
          if(paisSelected?.id == '+54' && !value) {
              return false;
          }
          return true;
        }),

        localidad: yup.mixed().test('validacion-localidad-argentina', 'Seleccione la localidad', function(value) {
          const paisSelected = this.parent.paisResidencia;
          if(paisSelected?.id == '+54' && !value) {
              return false;
          }
          return true;
        }),

        provinciaEstado: yup.string().test('validacion-provincia-otro', 'Ingrese la provincia/estado', function(value) {
          const paisSelected = this.parent.paisResidencia;     
          if(paisSelected?.id != '+54' && !value) {
              return false;
          }
          return true;
        }),

        localidadCiudad: yup.string().test('validacion-localidad-otro', 'Ingrese la localidad/ciudad', function(value) {
          const paisSelected = this.parent.paisResidencia;
          if(paisSelected?.id != '+54' && !value) {
              return false;
          }
          return true;
        }),

      });
    },
  },
  watch: {
    'formData.provincia.id'(newValue) {
      if (newValue) {
        this.localidades = jsonLocalidades;
        this.localidades = this.localidades.filter((localidad: Localidad) => localidad.id === newValue);
      }
    },
    'formData.tipoAcreditado.id'(newValue) {
      if (newValue !== 2713 && newValue !== 2711) {
        this.formData.numeroLegajo = ''
      }
    }
  },
  methods: {
    onInvalidSubmit(values: any) {
      const errores:number = Object.values(values?.errors || {}).flat().length;
      Swal.fire({ title: "Hay errores", html: "Por favor revise el formulario (" + errores + " error/es)", icon: "error"});
    },
    async validarDni() {
      this.isSubmitting = true;

      try {
        let acreditadoExistente:Acreditado = await suiteService.findAcreditadoByFilters(suiteConfig.evento, "dni="+this.formData.dni) as Acreditado;
        if (acreditadoExistente) {
          this.isSubmitting = false;
          Swal.fire({ 
              title: "Atención", 
              html: "El DNI / Pasaporte ingresado ya fue registrado<br/><br/>Le enviamos un correo con su credencial digital<br/><br/>Si no le llega el correo puede descargar la credencial usando el botón <b>'YA ME ACREDITE'</b> de esta página.", icon: "info" }).then(() => {
                this.isSubmitting = false;
              });
          return;
        }
      } catch(error) {
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    },    
    async onSubmit() {
      this.isSubmitting = true;

      try {
        let acreditadoExistente:Acreditado[] =  await suiteService.findAcreditadosByFilters(suiteConfig.evento, "dni="+encodeURIComponent(this.formData.dni) ) ;
        if (acreditadoExistente.length > 0) {
            this.isSubmitting = false;
              Swal.fire({ title: "Atención",  html: "¡Ya se acreditó con este DNI / Pasaporte!<br/><br/>Le enviamos un correo con su credencial digital<br/><br/>Si no le llega el correo puede descargar la credencial usando el botón <b>'YA ME ACREDITE'</b> de esta página.", icon: "info" }).then(() => {
                  this.isSubmitting = false;
              });
              return;
        }

        const acreditado:Acreditado = {} as Acreditado;
        
        acreditado.tipoAcreditado = this.formData.tipoAcreditado,
        acreditado.estadoAcreditado = { "id": VERIFICADO } as EstadoAcreditado;
        acreditado.origenAcreditado = { "id" : ORIGEN_ACREDITADO } as OrigenAcreditado;
        acreditado.dni = this.formData.dni;
        acreditado.nombre = this.formData.nombre;
        acreditado.apellido = this.formData.apellido;
        acreditado.empresa = this.formData.empresa;
        acreditado.cargo = this.formData.ocupacion;
        acreditado.telefono = this.selectedCountry.id + this.formData.codigoArea + this.formData.numeroTelefono;
        acreditado.mail = this.formData.mail;
        acreditado.cargo = this.formData.ocupacion;

        acreditado.dato1 = this.formData.numeroLegajo;
        acreditado.dato2 = this.formData.paisResidencia?.descripcion;

        if(this.formData.paisResidencia?.id == "+54") {
          acreditado.dato3 = this.formData.provincia?.descripcion;
          acreditado.dato4 = this.formData.localidad?.descripcion;
        } else {
          acreditado.dato3 = this.formData.provinciaEstado;
          acreditado.dato4 = this.formData.localidadCiudad;
        }

        acreditado.cantidad = 1;
        acreditado.notificar = true;
        acreditado.modificado = SAVE;
        
        const acreditadoActualizado: Acreditado = await suiteService.saveOrUpdate(suiteConfig.evento, acreditado);

    
        if (acreditadoActualizado) {
          this.isSubmitting = false;
          Swal.fire({ title: "Atención",  html: "¡Su acreditación fue generada correctamente!<br/><br/>Le enviamos un correo con su credencial digital<br/><br/>Si no le llega el correo puede descargar la credencial usando el botón <b>'YA ME ACREDITE'</b> de esta página.", icon: "info" }).then(() => {
            this.$router.go(0);
          });
        }
      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      }
    },
  }
});
</script>